/**
 * Created by bcole on 1/13/20.
 */
const Actions = {
    SET_USER: "SET_USER",
    SET_PROJECT: "SET_PROJECT",
    SET_INITAL_STATE: "SET_INITAL_STATE",
    SET_PROJECTS: "SET_PROJECTS",
    ADD_SWIMLANE: "ADD_SWIMLANE",
    MOVE_TASK: "MOVE_TASK",
    MOVE_TASK_TO_BACKLOG: "MOVE_TASK_TO_BACKLOG",
    MOVE_TASK_FROM_BACKLOG: "MOVE_TASK_FROM_BACKLOG",
    MOVE_BACKLOG_TASK: "MOVE_BACKLOG_TASK",
    SET_BACKLOG: "SET_BACKLOG",
    SET_SPRINTS: "SET_SPRINTS",
    ADD_SPRINT: "ADD_SPRINT",
    UPDATE_SPRINT: "UPDATE_SPRINT",
    SET_SELECTED_SPRINT: "SET_SELECTED_SPRINT",
    SET_SWIMLANES: "SET_SWIMLANES",
    SET_BACKLOG_TICKETS: "SET_BACKLOG_TICKETS",
    APPEND_BACKLOG_TICKETS: "APPEND_BACKLOG_TICKETS",
    SET_SPRINT_TICKETS: "SET_SPRINT_TICKETS",
    ADD_TASK: "ADD_TASK",
    UPDATE_TASK: "UPDATE_TASK",
    OPEN_TASK: "OPEN_TASK",
    CLOSE_TASK: "CLOSE_TASK",
    SET_TICKET_TEMPLATE: "SET_TICKET_TEMPLATE",
    SET_BUG_TEMPLATE: "SET_BUG_TEMPLATE",
    ADD_PHASE: "ADD_PHASE",
    REMOVE_PHASE: "REMOVE_PHASE",
    MOVE_PHASE: "MOVE_PHASE",
    SET_SCOPE: "SET_SCOPE",
    SET_SCOPE_TYPES: "SET_SCOPE_TYPES",
    SET_SCOPE_TYPE_NAME: "SET_SCOPE_TYPE_NAME",
    REMOVE_SCOPE_TYPE: "REMOVE_SCOPE_TYPE",
    ADD_SCOPE_ITEMS: "ADD_SCOPE_ITEMS",
    REMOVE_SCOPE_ITEM: "REMOVE_SCOPE_ITEM",
    MOVE_SCOPE_ITEM: "MOVE_SCOPE_ITEM",
    UPDATE_SCOPE_ITEM: "UPDATE_SCOPE_ITEM",
    ADD_SCOPE_TYPE: "ADD_SCOPE_TYPE",
    SET_PHASES: "SET_PHASES",
    UPDATE_PHASE: "UPDATE_PHASE",
    SET_BACKLOG_FILTERS: "SET_BACKLOG_FILTERS",
    SET_BUGS: "SET_BUGS",
    APPEND_BUGS: "APPEND_BUGS",
    ADD_BUG: "ADD_BUG",
    UPDATE_BUG: "UPDATE_BUG",
    MERGE_BUG: "MERGE_BUG",
    SET_BUG_FILTERS: "SET_BUG_FILTERS",
    SET_SUPPORT_TICKETS: "SET_SUPPORT_TICKETS",
    APPEND_SUPPORT_TICKETS: "APPEND_SUPPORT_TICKETS",
    SET_PLAN_LIMITS: "SET_PLAN_LIMITS",
    ADD_SUPPORT_TICKET: "ADD_SUPPORT_TICKET",
    UPDATE_SUPPORT_TICKET: "UPDATE_SUPPORT_TICKET",
    SET_SUPPORT_FILTERS: "SET_SUPPORT_FILTERS",
    SET_PERMISSIONS: "SET_PERMISSIONS",
    SET_DESIGN_PAGE: "SET_DESIGN_PAGE",
    UPDATE_DESIGN_PAGE: "UPDATE_DESIGN_PAGE",
    SET_NEW_TASK_DRAFT: "SET_NEW_TASK_DRAFT",
};

export default Actions;